<template>
  <div>
  <van-form @submit="onSubmit" @failed="onFailed">
    <van-divider contentPosition="center" >
      编辑-房产信息
    </van-divider>
    <van-field
            clearable
            label="产权类型"
            required
            name="propertyType"
            placeholder="请选择产权类型"
            right-icon="records"
            v-model="form.propertyType"
            :rules="[{ required: true, message: '请选择产权类型' }]"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('housePropertyType')"
    />
    <van-field
            clearable
            label="不动产单元号"
            name="immovableEstateNo"
            placeholder="请输入不动产单元号"
            type="string"
            required
            :readonly="isReadOnly"
            v-model="form.immovableEstateNo"
    />

    <van-field
            clearable
            label="产权证号"
            name="propertyCardNumber"
            placeholder="请输入产权证号"
            type="string"
            required
            :readonly="isReadOnly"
            v-model="form.propertyCardNumber"
    />
    <van-field
            clearable
            label="坐落区域"
            name="houseCitys"
            placeholder="请选择房产类型"
            right-icon="records"
            required
            v-model="form.houseCitys"
            :rules="[{ required: true, message: '请选择房产类型' }]"
            :readonly="isReadOnly"
            @click-right-icon="showAreaPopup('houseCitys')"
    />

    <!-- 弹出区域选择器 -->
    <van-popup v-model="showArea" position="bottom">
      <van-area
              :area-list="areaList"
              v-model="selectedArea"
              @confirm="onAreaConfirm"
              @cancel="onAreaCancel"
      />
    </van-popup>


    <van-field
            clearable
            label="座落地址(房产证地址)"
            name="detailedAdress"
            placeholder="请输入座落地址(房产证地址)"
            type="string"
            required
            :readonly="isReadOnly"
            v-model="form.detailedAdress"
    />

    <van-field
            clearable
            label="房产类型"
            name="realestateType"
            placeholder="请选择房产类型"
            right-icon="records"
            required
            v-model="form.realestateType"
            :rules="[{ required: true, message: '请选择房产类型' }]"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('realestateType')"
    />

    <van-field
            clearable
            label="权利类型"
            name="guarantyCertify"
            placeholder="请选择权利类型"
            right-icon="records"
            required
            v-model="form.guarantyCertify"
            :rules="[{ required: true, message: '请选择权利类型' }]"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('guarantyCertify')"
    />

    <van-field
            clearable
            label="权利性质"
            name="rightNature"
            placeholder="请输入权利性质"
            type="string"
            :readonly="isReadOnly"
            v-model="form.rightNature"
    />

    <van-field
            clearable
            label="用途(房产证)"
            name="housePurpose"
            placeholder="请输入用途(房产证)"
            type="string"
            :readonly="isReadOnly"
            v-model="form.housePurpose"
    />

    <van-field
            clearable
            label="建筑面积"
            name="houseArea"
            placeholder="请输入建筑面积"
            type="number"
            :readonly="isReadOnly"
            :rules="[{ required: true, message: '请输入建筑面积' }]"
            v-model="form.houseArea"
    />
    <van-divider contentPosition="center" >
    </van-divider>

    <van-field
            clearable
            label="世联评估价(万)"
            name="pgPrice"
            placeholder="请输入世联评估价"
            type="number"
            :readonly="isReadOnly"
            required
            :rules="[{ required: true, message: '请输入世联评估价' }]"
            v-model="form.pgPrice"
    />

    <van-field
            clearable
            label="房估估评估价(万)"
            name="fggPrice"
            placeholder="请输入房估估评估价"
            type="number"
            required
            :readonly="isReadOnly"
            :rules="[{ required: true, message: '请输入房估估评估价' }]"
            v-model="form.fggPrice"
    />

    <van-field
            clearable
            label="最终评估价(万)"
            name="finalPrice"
            placeholder="请输入最终评估价"
            type="number"
            :readonly="isReadOnly"
            v-model="form.finalPrice"
    />


    <van-divider contentPosition="center" >
    </van-divider>
    <van-field
            clearable
            label="房产登记日期"
            name="registerDate"
            v-model="form.registerDate"
            :readonly="isReadOnly"
            placeholder="房产登记日期"
            right-icon="records"
            @click-right-icon="showDatePopup('registerDate')"
    />
    <van-field
            clearable
            label="产权到期日"
            name="propertyDueDate"
            v-model="form.propertyDueDate"
            :readonly="isReadOnly"
            placeholder="产权到期日"
            right-icon="records"
            @click-right-icon="showDatePopup('propertyDueDate')"
    />
    <van-field
            clearable
            label="房屋建筑日期"
            name="buildDate"
            v-model="form.buildDate"
            :readonly="isReadOnly"
            placeholder="房屋建筑日期"
            right-icon="records"
            @click-right-icon="showDatePopup('buildDate')"
    />
    <van-field
            clearable
            label="房龄"
            name="hourseAge"
            placeholder="请输入房龄"
            type="number"
            :readonly="isReadOnly"
            v-model="form.hourseAge"
    />
    <van-field
            clearable
            label="土地使用生效日期"
            name="takeEffectTime"
            v-model="form.takeEffectTime"
            :readonly="isReadOnly"
            placeholder="土地使用生效日期"
            right-icon="records"
            @click-right-icon="showDatePopup('takeEffectTime')"
    />
    <van-field
            clearable
            label="土地使用失效日期"
            name="failureTime"
            v-model="form.failureTime"
            :readonly="isReadOnly"
            placeholder="土地使用失效日期"
            right-icon="records"
            @click-right-icon="showDatePopup('failureTime')"
    />
    <van-field
            clearable
            label="房屋购买日期"
            name="purchaseDate"
            v-model="form.purchaseDate"
            :readonly="isReadOnly"
            placeholder="房屋购买日期"
            right-icon="records"
            @click-right-icon="showDatePopup('purchaseDate')"
    />
    <van-field
            clearable
            label="房屋过户日期"
            name="transferDate"
            v-model="form.transferDate"
            :readonly="isReadOnly"
            placeholder="房屋过户日期"
            right-icon="records"
            @click-right-icon="showDatePopup('transferDate')"
    />

    <van-divider contentPosition="center" >
    </van-divider>
    <van-field
            clearable
            label="一押贷款余额(元)"
            name="firstLoanBalance"
            placeholder="请输入一押贷款余额"
            type="number"
            :readonly="isReadOnly"
            v-model="form.firstLoanBalance"
    />
    <van-field
            clearable
            label="抵押日期"
            name="firstMortgageDate"
            v-model="form.firstMortgageDate"
            :readonly="isReadOnly"
            placeholder="抵押日期"
            right-icon="records"
            @click-right-icon="showDatePopup('firstMortgageDate')"
    />
    <van-field
            clearable
            label="剩余期限(月)"
            name="pledgeSurplusTerm"
            placeholder="请输入剩余期限"
            type="number"
            :readonly="isReadOnly"
            v-model="form.pledgeSurplusTerm"
    />
    <template v-if="isFirstMortgageDate">
    <van-field
            clearable
            label="债权人"
            name="mortgagePerson"
            placeholder="请输入债权人"
            type="number"
            required
            :readonly="isReadOnly"
            v-model="form.mortgagePerson"
    />

    <van-field
            clearable
            label="类型"
            name="mortgageType"
            v-model="form.mortgageType"
            :readonly="isReadOnly"
            placeholder="类型"
            required
            right-icon="records"
            @click-right-icon="showPopup('mortgageType')"
    />

    <van-field
            clearable
            label="二押贷款余额(元)"
            name="secondLoanBalance"
            placeholder="请输二押贷款余额"
            type="number"
            :readonly="isReadOnly"
            v-model="form.secondLoanBalance"
    />
    <van-field
            clearable
            label="抵押日期"
            name="secondMortgageDate"
            v-model="form.secondMortgageDate"
            :readonly="isReadOnly"
            placeholder="抵押日期"
            right-icon="records"
            @click-right-icon="showDatePopup('secondMortgageDate')"
    />
    <van-field
            clearable
            label="剩余期限(月)"
            name="secondPledgeSurplusTerm"
            placeholder="请输入二押贷款剩余期限"
            type="number"
            required
            :readonly="isReadOnly"
            v-model="form.secondPledgeSurplusTerm"
    />
    <van-field
            clearable
            label="债权人"
            name="secondMortgagePerson"
            placeholder="请输入二押债权人"
            type="number"
            :readonly="isReadOnly"
            v-model="form.secondMortgagePerson"
    />

    <van-field
            clearable
            label="类型"
            name="secondMortgageType"
            v-model="form.secondMortgageType"
            :readonly="isReadOnly"
            placeholder="类型"
            required
            right-icon="records"
            @click-right-icon="showPopup('secondMortgageType')"
    />
    </template>

    <div style="margin: 16px;" >
      <van-row gutter="20">
        <van-col span="12" v-if="!isReadOnly">
        <van-button round block :loading="loading" type="info" native-type="submit" size="small">
          保存
        </van-button>
        </van-col>
        <van-col :span="!isReadOnly?12:24">
        <van-button round block @click="goBack" size="small">
          返回
        </van-button>
        </van-col>
      </van-row>

    </div>
  </van-form>

  <van-popup position="bottom" v-model="popupShow" :overlay="true">
    <van-picker title="请选择" show-toolbar :columns="columns"
                @confirm="onConfirm"
                @cancel="popupShow=false"/>

  </van-popup>

  <van-popup position="bottom" v-model="popupMultipleShow" :overlay="true">
    <van-picker title="多选"
                show-toolbar
                cancel-button-text="关闭"
                confirm-button-text="选择"
                :columns="multipleColumns"
                @confirm="onMultipleSelect"
                @cancel="onMultipleConfirm"/>

  </van-popup>

    <van-popup
            v-model="showDatePicker"
            position="bottom">
      <van-datetime-picker
              type="date"
              @confirm="confirmDate"
              :min-date="minDate"
              @cancel="showDatePicker=false"
      />
    </van-popup>

  </div>

</template>

<script>
  import { Area } from 'vant';
  import { areaList } from "@vant/area-data";
import {dictData} from "@/vue/utils/interviewData";
import { cloneDeep } from 'lodash'
import moment from 'moment'
import {getHouseInfo, saveCustomerHouse} from "../../../../../api/loanInfo";
import {eventBus} from '@/vue/utils/eventBus'
import Dialog from "vant/lib/dialog";
export default {
  name: 'warrant-mortgage',
  props: {
    mortgageId: {
      type: String,
      default: ''
    },
    isReadOnly:{
      type:Boolean,
      default:false
    }
  },
  components: {
    [Area.name]: Area
  },
  watch: {
    'form.changeBankLoanBalance'(value) {
      if (value>0) {
        this.isFirstMortgageDate = true
        setTimeout(() => {
          this.form.secondMortgageDate=null
          this.form.firstMortgageDate=null
        }, 200)
      } else {
        this.isFirstMortgageDate = false
      }
    },


  },
  data() {
    return {
      // 对应的字段名称
      field: undefined,
      areaList:areaList,
      showArea: false, // 控制区域选择弹窗的显示
      selectedArea: '', // 存储选择的区域
      columns: [],
      isStructure:false,
      multipleColumns: [],
      // 单选
      popupShow: false,
      // 多选
      popupMultipleShow: false,
      // 时间选择
      showDatePicker: false,
      loading:false,
      isFirstMortgageDate:false,
      minDate: new Date(1980, 0, 1),
      form: {
        propertyType: '',
        immovableEstateNo: '',
        propertyCardNumber: '',
        detailedAdress: '',
        realestateType: '',
        guarantyCertify: '',
        rightNature: '',
        housePurpose: '',
        houseArea: '',
        pgPrice: '',
        fggPrice: '',
        finalPrice: '',
        registerDate: '',
        propertyDueDate: '',
        buildDate: '',
        hourseAge: '',
        takeEffectTime: '',
        failureTime: '',
        purchaseDate: '',
        transferDate: '',
        firstLoanBalance:0,
        firstMortgageDate: '',
        pledgeSurplusTerm: '',
        mortgagePerson: '',
        mortgageType: '',
        secondLoanBalance: '',
        secondMortgageDate: '',
        secondPledgeSurplusTerm: '',
        secondMortgagePerson: '',
        secondMortgageType: '',
        provice:'',
        city:'',
        district:'',
      }
    }
  },
  mounted() {
    let self = this
    this.loadHouses()
  },
  destroyed() {
  },
  methods: {
    goBack() {
      eventBus.$emit('goBackToRiskFirstEdit')
    },
    loadHouses() {
      const self=this
      getHouseInfo(this.mortgageId).then(res => {
        if (res.success) {
          this.form = res.data
          this.form.propertyType = dictData['propertyTypeMap'][this.form.propertyType]
          this.form.realestateType = dictData['realestateTypeMap'][this.form.realestateType]
          this.form.guarantyCertify = dictData['guarantyCertifyMap'][this.form.guarantyCertify]
          this.form.secondMortgageType = dictData['mortgageTypeMap'][this.form.secondMortgageType]
          this.form.mortgageType = dictData['mortgageTypeMap'][this.form.mortgageType]
          if(this.form.firstLoanBalance!=null&&this.form.firstLoanBalance>0){
            setTimeout(() => {
              self.isFirstMortgageDate=true
            }, 200)
          }
          if(this.form.rightNature==null){
            setTimeout(() => {
              self.form.rightNature=null
            }, 200)
          }
          this.form.registerDate != null ? (this.form.registerDate = moment(this.form.registerDate).format('YYYY-MM-DD')) :
          setTimeout(() => {
            self.form.registerDate=null
          }, 200)
          this.form.propertyDueDate != null ? (this.form.propertyDueDate = moment(this.form.propertyDueDate).format('YYYY-MM-DD')) :
                  setTimeout(() => {
                    self.form.propertyDueDate=null
                  }, 200)
          this.form.buildDate != null ? (this.form.buildDate = moment(this.form.buildDate).format('YYYY-MM-DD')) :
                  setTimeout(() => {
                    self.form.buildDate=null
                  }, 200)
          this.form.takeEffectTime != null ? (this.form.takeEffectTime = moment(this.form.takeEffectTime).format('YYYY-MM-DD')) :
                  setTimeout(() => {
                    self.form.takeEffectTime=null
                  }, 200)
          this.form.failureTime != null ? (this.form.failureTime = moment(this.form.failureTime).format('YYYY-MM-DD')) :
                  setTimeout(() => {
                    self.form.failureTime=null
                  }, 200)
          this.form.purchaseDate != null ? (this.form.purchaseDate = moment(this.form.purchaseDate).format('YYYY-MM-DD')) :
                  setTimeout(() => {
                    self.form.purchaseDate=null
                  }, 200)
          this.form.transferDate != null ? (this.form.transferDate = moment(this.form.transferDate).format('YYYY-MM-DD')) :
                  setTimeout(() => {
                    self.form.transferDate=null
                  }, 200)
          this.form.firstMortgageDate != null ? (this.form.firstMortgageDate = moment(this.form.firstMortgageDate).format('YYYY-MM-DD')) :
                  setTimeout(() => {
                    self.form.firstMortgageDate=null
                  }, 200)
          this.form.secondMortgageDate != null ? (this.form.secondMortgageDate = moment(this.form.secondMortgageDate).format('YYYY-MM-DD')) :
                  setTimeout(() => {
                    self.form.secondMortgageDate=null
                  }, 200)
          const provincesList=["北京市","天津市","上海市","重庆市"]
          if(provincesList.includes(this.form.province)&&this.form.province!=null){
            this.form.houseCitys =this.form.province+"/"+this.form.district
          }else{
            this.form.houseCitys =this.form.province+"/"+this.form.city+"/"+this.form.district
          }


        }
      })
    },
    // 确认选择
    onMultipleConfirm(value) {
      //this.form[this.field] = value
      this.popupMultipleShow = false
    },
    // 确认选择
    onMultipleSelect(value) {
      let _value = this.form[this.field]
      if (_value) {
        this.form[this.field] = _value + ',' + value
      } else {
        this.form[this.field] = value
      }
      this.$toast('当前选择：' + this.form[this.field])
    },
    // 确认选择
    onConfirm(value) {
      this.form[this.field] = value
      this.popupShow = false
    },
    // 激活弹出选择器
    showPopup(value) {
      if (!this.isReadOnly) {
        this.field = value
        this.columns = dictData[value]
        this.popupShow = true
      }
    },
    // 激活弹出多选选择器
    showMuliplePopup(value) {
      // 赋值对应字段
      if (!this.isReadOnly) {
        this.field = value
        this.multipleColumns = dictData[value]
        this.popupMultipleShow = true
      }
    },
    // 激活弹出时间选择器
    showDatePopup(value) {
      // 赋值对应字段
      if (!this.isReadOnly) {
        this.field = value
        this.showDatePicker = true
      }

    },
    confirmDate(value) {
      this.form[this.field] = value.toLocaleString()
      this.showDatePicker = false
    },

    // 提交
    onSubmit(values) {
      const self=this
      if (!this.loading) {
        this.loading = true
        let params = cloneDeep(this.form)
        if (params.propertyType) {
          params.propertyType=self.findKeyByValue(dictData["propertyTypeMap"],params.propertyType)
        }
        if (params.realestateType) {
          params.realestateType=self.findKeyByValue(dictData["realestateTypeMap"],params.realestateType)
        }
        if (params.guarantyCertify) {
          params.guarantyCertify=self.findKeyByValue(dictData["guarantyCertifyMap"],params.guarantyCertify)
        }
        if (params.secondMortgageType) {
          params.secondMortgageType=self.findKeyByValue(dictData["mortgageTypeMap"],params.secondMortgageType)
        }
        if (params.mortgageType) {
          params.mortgageType=self.findKeyByValue(dictData["mortgageTypeMap"],params.mortgageType)
        }
        if(params.registerDate){
          params.registerDate=moment(params.registerDate).format('YYYY-MM-DD')
        }
        if(params.propertyDueDate){
          params.propertyDueDate=moment(params.propertyDueDate).format('YYYY-MM-DD')
        }
        if(params.buildDate){
          params.buildDate=moment(params.buildDate).format('YYYY-MM-DD')
        }
        if(params.takeEffectTime){
          params.takeEffectTime=moment(params.takeEffectTime).format('YYYY-MM-DD')
        }
        if(params.failureTime){
          params.failureTime=moment(params.failureTime).format('YYYY-MM-DD')
        }
        if(params.purchaseDate){
          params.purchaseDate=moment(params.purchaseDate).format('YYYY-MM-DD')
        }
        if(params.transferDate){
          params.transferDate=moment(params.transferDate).format('YYYY-MM-DD')
        }
        if(params.firstMortgageDate){
          params.firstMortgageDate=moment(params.firstMortgageDate).format('YYYY-MM-DD')
        }
        if(params.secondMortgageDate){
          params.secondMortgageDate=moment(params.secondMortgageDate).format('YYYY-MM-DD')
        }
        // 保存
        saveCustomerHouse(params).then(res => {
          Dialog.alert({
            message: res.msg
          })
          this.loading = false
          self.goBack()
        }).finally(() => {
          this.loading = false
        })
      }

    },
    onFailed(errorInfo) {

    },
    findKeyByValue(map, targetValue) {
      // 检查 map 是否是 Object 类型
      if (typeof map === "object" && !Array.isArray(map) && map !== null) {
        for (const [key, value] of Object.entries(map)) {
          if (value === targetValue) {
            return key; // 找到匹配的 key 后返回
          }
        }
      } else if (map instanceof Map) {
        // 如果是 Map 类型
        for (const [key, value] of map) {
          if (value === targetValue) {
            return key; // 找到匹配的 key 后返回
          }
        }
      }
    // 没有匹配的 key
    return undefined;
  },
    showAreaPopup(fieldName) {
      // 显示区域选择弹窗
      this.showArea = true;
    },
    onAreaConfirm(selected) {
      const provice = selected[0].name
      const city = selected[1] ? selected[1].name : ''
      const district = selected[2] ? selected[2].name : ''
      this.form.province=provice
      this.form.city=city
      this.form.district=district
      // 拼接地区名，并保存到表单字段
      const provincesList=["北京市","天津市","上海市","重庆市"]
      if(provincesList.includes(provice)){
        this.form.houseCitys =provice+"/"+district
        this.form.city=district
      }else{
        this.form.houseCitys =provice+"/"+city+"/"+district
      }
      this.showArea = false;
    },
    onAreaCancel() {
      // 点击取消时，关闭弹窗
      this.showArea = false;
    }

}

}
</script>

<style scoped>
.htmlContent {
  overflow: auto;
}
</style>
